import React from 'react';

interface SwitchProps {
  options: string[];
  selectedOption: string;
  onOptionChange: (option: string) => void;
  className?: string;
}

export const Switch: React.FC<SwitchProps> = ({
  options,
  selectedOption,
  onOptionChange,
  className = '',
}) => {
  return (
    <div className={`flex rounded-full p-1 ${className}`}>
      {options.map(option => (
        <button
          key={option}
          onClick={() => onOptionChange(option)}
          className={`px-4 py-2 text-sm font-medium rounded-full transition-all duration-200 flex-1 ${
            selectedOption === option
              ? 'bg-white border border-[#C3C6BC]'
              : 'text-gray-600 hover:text-gray-900'
          }`}
        >
          {option}
        </button>
      ))}
    </div>
  );
};
